var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(-77 -309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(77 309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary-upstroke",
    d: "M-.273.535A.727.727,0,0,1-1-.192V-.273A.727.727,0,0,1-.273-1a.727.727,0,0,1,.727.727v.081A.727.727,0,0,1-.273.535Z",
    transform: "translate(11.909 4.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary-upstroke-2",
    "data-name": "secondary-upstroke",
    d: "M-.273.535A.727.727,0,0,1-1-.192V-.273A.727.727,0,0,1-.273-1a.727.727,0,0,1,.727.727v.081A.727.727,0,0,1-.273.535Z",
    transform: "translate(8.273 4.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary-upstroke-3",
    "data-name": "secondary-upstroke",
    d: "M-.273.535A.727.727,0,0,1-1-.192V-.273A.727.727,0,0,1-.273-1a.727.727,0,0,1,.727.727v.081A.727.727,0,0,1-.273.535Z",
    transform: "translate(4.636 4.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary-upstroke-4",
    "data-name": "secondary-upstroke",
    d: "M-.273.535A.727.727,0,0,1-1-.192V-.273A.727.727,0,0,1-.273-1a.727.727,0,0,1,.727.727v.081A.727.727,0,0,1-.273.535Z",
    transform: "translate(11.909 8.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary-upstroke-5",
    "data-name": "secondary-upstroke",
    d: "M-.273.535A.727.727,0,0,1-1-.192V-.273A.727.727,0,0,1-.273-1a.727.727,0,0,1,.727.727v.081A.727.727,0,0,1-.273.535Z",
    transform: "translate(8.273 8.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "secondary-upstroke-6",
    "data-name": "secondary-upstroke",
    d: "M-.273.535A.727.727,0,0,1-1-.192V-.273A.727.727,0,0,1-.273-1a.727.727,0,0,1,.727.727v.081A.727.727,0,0,1-.273.535Z",
    transform: "translate(4.636 8.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M1.455,0h9.859a1.456,1.456,0,0,1,1.455,1.455V14.545A1.456,1.456,0,0,1,11.313,16H1.455A1.456,1.456,0,0,1,0,14.545V1.455A1.456,1.456,0,0,1,1.455,0Zm9.859,14.545V1.455H1.454V14.545Z",
    transform: "translate(16 0) rotate(90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_23",
    "data-name": "Line 23",
    d: "M6.273.455H-.273A.727.727,0,0,1-1-.273.727.727,0,0,1-.273-1H6.273A.727.727,0,0,1,7-.273.727.727,0,0,1,6.273.455Z",
    transform: "translate(82 324.545)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.0d64cefeb32e53ba46062e91bcb62350.svg";
export { ForwardRef as ReactComponent };